import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  width: 100%;
`

export const AmountWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S4};
  justify-content: flex-end;
  width: 100%;
`
